module.exports = __webpack_public_path__ + "media/images/favicon-6b60d2d78b7f850e775fdac8dbcc5e32.ico";